import { Link } from 'react-router-dom';
import { PostVisual } from './PostVisual';
import { PlatformIcons } from './PlatformIcon';
import { pillarByKey, statusByKey } from './socialOptions';
import type { MarketingDesign } from '../../core/types/marketing';
import type { SocialPost } from '../../core/types/social';
const statusDot: Record<SocialPost['status'], string> = {
  idee: 'border border-dashed border-muted/60 bg-transparent',
  concept: 'bg-blush',
  klaar: 'bg-clay',
  geplaatst: 'bg-sage'
};

/** Een post als kaartje in de weekplanner. */
export function PostChip({
  post,
  design
}: {
  post: SocialPost;
  design?: MarketingDesign;
}) {
  const pillar = pillarByKey(post.pillar);
  const status = statusByKey(post.status);
  return <Link to={`/be/social/${post.id}`} className={`group flex gap-2.5 rounded-md border bg-white p-2 transition-colors duration-150 ease-soft hover:border-ink/30 lg:flex-col ${post.status === 'idee' ? 'border-dashed border-line' : 'border-line'} ${post.status === 'geplaatst' ? 'opacity-70' : ''}`} data-id="element-4615" data-mp="2nmlbltaemw6s">
      <PostVisual post={post} design={design} className="h-14 w-11 shrink-0 rounded-sm lg:aspect-[4/5] lg:h-auto lg:w-full" data-id="element-4616" data-mp="1hs9oqaxdvbu" />
      <span className="min-w-0 flex-1" data-id="element-4617" data-mp="3ny4r7sbb1clk">
        <span className="flex items-center gap-1.5 text-[12px] tabular-nums text-muted" data-id="element-4618" data-mp="3nx36sx8efdr6">
          <span className={`h-2 w-2 shrink-0 rounded-full ${statusDot[post.status]}`} title={status.label} data-id="element-4619" data-mp="3iztg7e99ww1r" />
          <span className="sr-only" data-id="element-4620" data-mp="3eyhtbghsaox9">{status.label} · </span>
          {post.time}
          <PlatformIcons platforms={post.platforms} className="ml-auto" data-id="element-4621" data-mp="39y3saielof8q" />
        </span>
        <span className="mt-0.5 line-clamp-2 block text-[13px] leading-snug text-ink" data-id="element-4622" data-mp="34yquj2m6xnrd">{post.title || 'Naamloze post'}</span>
        <span className="mt-1 flex items-center gap-1.5 text-[11px] text-muted" data-id="element-4623" data-mp="3018u60m8oguz">
          <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${pillar.dot}`} aria-hidden="true" data-id="element-4624" data-mp="138fcdfalpqsv" />
          <span className="truncate" data-id="element-4625" data-mp="y8atxjq4um00">{pillar.label}</span>
        </span>
      </span>
    </Link>;
}